
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ReasonStatusGrid extends Serenity.EntityGrid<ReasonStatusRow, any> {
        protected getColumnsKey() { return 'OMS.ReasonStatus'; }
        protected getDialogType() { return ReasonStatusDialog; }
        protected getIdProperty() { return ReasonStatusRow.idProperty; }
        protected getInsertPermission() { return ReasonStatusRow.insertPermission; }
        protected getLocalTextPrefix() { return ReasonStatusRow.localTextPrefix; }
        protected getService() { return ReasonStatusService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}